export default __webpack_public_path__ + "static/media/infiniteScroll.28805caf.png";